import mixpanel from 'mixpanel-browser';
import { isProduction } from './utils/isProduction';

const MIXPANEL_KEY = 'd4163fbfa10b2f6b9b0dceb6898c3ae9';

// Route data to Mixpanel's EU servers
mixpanel.init(MIXPANEL_KEY, {
  api_host: 'https://api-eu.mixpanel.com',
  persistence: 'localStorage',
});

const analyticsEnabled = isProduction();

const actions = {
  identify: (id) => {
    if (analyticsEnabled) mixpanel.identify(id);
  },
  track: (name, props) => {
    if (analyticsEnabled) mixpanel.track(name, props);
  },
  register: (props) => {
    if (analyticsEnabled) mixpanel.register(props);
  },
  set: (props) => {
    if (analyticsEnabled) mixpanel.people.set(props);
  },
  increment: (name) => {
    if (analyticsEnabled) mixpanel.people.increment(name);
  },
  setOnce: (props) => {
    if (analyticsEnabled) mixpanel.people.set_once(props);
  },
};

export const Analytics = actions;
